import {handleInitialNavigation, navigate} from '../actions/navigation'
import {placeOrder, updateOrder} from '../actions/placed-order'
import {makeReservation} from '../actions/reservation'
import {sendRsvp, sendRsvpOld, updateRsvp, updateRsvpOld} from '../actions/rsvp'
import {State} from '../types/state'

export const isRequestPending = (state: State, actionType: string) => !!state.pendingRequests.loading[actionType]

export const isCheckoutActionPending = (state: State): boolean => {
  const updateOrderInProgress = isRequestPending(state, updateOrder.typePrefix)

  const placeOrderInProgress = isRequestPending(state, placeOrder.typePrefix)

  const reserveTicketsInProgress = isRequestPending(state, makeReservation.typePrefix)

  const navigateInProgress = isRequestPending(state, navigate.typePrefix)

  const initialNavigationInProgress = isRequestPending(state, handleInitialNavigation.typePrefix)

  return (
    updateOrderInProgress ||
    placeOrderInProgress ||
    reserveTicketsInProgress ||
    (navigateInProgress && !initialNavigationInProgress)
  )
}

export const isRsvpActionPending = (state: State): boolean => {
  const sendRsvpInProgress = isRequestPending(state, sendRsvp.typePrefix)

  const sendRsvpOldInProgress = isRequestPending(state, sendRsvpOld.typePrefix)

  const updateRsvpInProgress = isRequestPending(state, updateRsvp.typePrefix)

  const updateRsvpOldInProgress = isRequestPending(state, updateRsvpOld.typePrefix)

  return sendRsvpInProgress || sendRsvpOldInProgress || updateRsvpInProgress || updateRsvpOldInProgress
}
